import { render, staticRenderFns } from "./patient-communication-preference-manager.vue?vue&type=template&id=2d47dd70&scoped=true"
import script from "./patient-communication-preference-manager.vue?vue&type=script&lang=js"
export * from "./patient-communication-preference-manager.vue?vue&type=script&lang=js"
import style0 from "./patient-communication-preference-manager.vue?vue&type=style&index=0&id=2d47dd70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d47dd70",
  null
  
)

export default component.exports